
<div class="casino-container">
  <!-- Tabs -->
  <ul class="nav nav-tabs casino-tabs">
    <li class="nav-item">
      <a class="nav-link" [class.active]="activeTab === 'popular'" (click)="activeTab = 'popular'">Popular</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [class.active]="activeTab === 'universe-live'" (click)="activeTab = 'universe-live'">Universe Live</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [class.active]="activeTab === 'universe-original'" (click)="activeTab = 'universe-original'">Universe Original</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [class.active]="activeTab === 'international'" (click)="activeTab = 'international'">International</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [class.active]="activeTab === 'slot'" (click)="activeTab = 'slot'">Slot</a>
    </li>
  </ul>

  <!-- Tab Content: Universe Live -->
  <div class="casino-grid" *ngIf="activeTab === 'universe-live'">
    <div class="casino-card" *ngFor="let game of universeLiveGames">
      <div class="card-img-placeholder">
        <div class="universe-badge"><i class="fas fa-gem"></i> universe</div>
        <div class="game-title">{{ game }}</div>
      </div>
    </div>
  </div>

  <!-- Tab Content: Universe Original -->
  <div class="casino-grid" *ngIf="activeTab === 'universe-original'">
    <div class="casino-card" *ngFor="let game of universeOriginalGames">
      <div class="card-img-placeholder original-bg">
        <div class="universe-badge"><i class="fas fa-gem"></i> universe</div>
        <div class="game-title">{{ game }}</div>
      </div>
    </div>
  </div>

  <!-- Empty states for others -->
  <div class="casino-grid" *ngIf="activeTab === 'popular' || activeTab === 'international' || activeTab === 'slot'">
    <p style="padding: 20px;">More games coming soon!</p>
  </div>
</div>
